/**
 * Query to fetch all sellers for dropdown selection
 */
const sellersListQuery = `
query MarketplaceSellersList($first: Int!) {
  marketplace_sellers(
    first: $first,
    order: [name_ASC]
  ) {
    edges {
      node {
        objectId
        name
        enabled
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default sellersListQuery;
